var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center flex-wrap"},_vm._l((_vm.content.buttons),function(button,i){return _c('ActionButton',{key:i,attrs:{"button":button}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }